import './App.css';

import { Canvas } from '@react-three/fiber';
import { Model } from './Content/Props/Model';
import { Env } from './Content/Environment';
import { Controls } from './Content/Controls';
import { Front } from './Content/UX/Front';
import { ScrollControls, Scroll, AdaptiveDpr, AdaptiveEvents } from '@react-three/drei';
import { Loading } from './Content/UX/Loading';
import { useState } from 'react';

import { isMobile } from 'react-device-detect';

function App() {
  const [progress, setProgress] = useState(0);

  const [startVideo, setStartVideo] = useState(false);

  return (
    <>
      <div
        id="html-overlay"
        style={{
          pointerEvents: 'none',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100svw',
          height: '100swh',
        }}
      />
      <Loading progress={progress} onStart={() => setStartVideo(true)} />
      <Canvas
        camera={{ position: [0.1, 1, -0.5], rotation: [0, Math.PI + 0.2, 0], far: 10, near: 0.1 }}
        id="webgl"
        gl={{
          antialias: true,
          powerPreference: 'low-power',
        }}
      >
        <AdaptiveDpr pixelated />
        <AdaptiveEvents />
        <Env />
        <Model setProgress={setProgress} playSignal={startVideo} />
        <ScrollControls horizontal={isMobile} pages={3} eps={1} distance={isMobile ? 2 : 1}>
          <Controls
            minVisibleHeight={0.65}
            visibleWidth={0.5}
            steps={[
              {
                position: [0.1, 0.95, -0.5],
                rotation: [0, Math.PI + 0.17, 0],
              },
              {
                position: [0.375, 1.03, 0.3245],
                rotation: [0, Math.PI / 2, 0],
              },
              {
                position: [0.9, 1.14, 1.515],
                rotation: [0, Math.PI / 2, 0],
              },
            ]}
          />
          <Scroll html>
            <Front playSignal={startVideo} />
          </Scroll>
        </ScrollControls>
      </Canvas>
    </>
  );
}

export default App;
